import { Card, Row, Col } from 'antd';
import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import { useFitness } from './data';
import Item from './Item';
import Chart from './Charts/Fitness';

const FitnessStatistic = () => {
  const { loading, fitness } = useFitness();

  return (
    <Auxiliary>
      <Card className="gx-card gx-p-15 gx-text-center" title="Status Kesehatan Pekerja">
        {loading ? "Sedang memuat..." : (
          <Row>
            {fitness.map((item, key) => {
              return (
                <Col span={12} key={`fitness-stats-${key}`}>
                  <Item loading={loading} label={item.name} value={item.value}/>
                </Col>
              );
            })}
          </Row>
        )}
        <hr />
        <Chart loading={loading} fitness={fitness} />
      </Card>
    </Auxiliary>
  );
}

export default FitnessStatistic;